<section class="dsm-flex-container analyzer-results-container">
    <div *ngIf="busy" class="flex-row">
        <usana-spinner [show]="busy" [delay]="100"></usana-spinner>
    </div>
    <div class="panel-container" *ngIf="!busy">
        <div class="panel pre-intro">
            <a href="javascript:void(0)" (click)="skinAnalyzerChangeAnswers()" class="exit-link"><i class="fa-solid fa-arrow-left"></i>
                <span translate="cart.skin.analyzer.change.answers"></span></a>
        </div>
        <div class="panel intro word-wrap">
            <div class="card text-center" *ngIf="!!productCards">
                <h1 class="category-hero-title heading-2" translate="cart.skin.analyzer.recommendations.title"></h1>
                <p translate="cart.skin.analyzer.recommendations.intro.description"></p>
            </div>
            <div class="card text-center" *ngIf="!productCards">
                <h1 class="category-hero-title heading-2" translate="cart.skin.analyzer.recommendations.not.found"></h1>
            </div>
            <img src="/image-service/ws/imgs/file/4993722/aws/w/0/h/0.img" alt="" height="104px">
        </div>
        <div class="panel button-line">
            <button class="button button-primary button-medium pull-left"
                    translate="cart.skin.analyzer.add.all.and.checkout" (click)="addAllAndGoToCart()"></button>
            <button class="button button-tertiary button-medium pull-right"
                    translate="cart.skin.analyzer.recommendations.create.sharelist" (click)="openCreateSharelist()"></button>
        </div>
        <ng-container *ngIf="!!productCards && productCards.length > 0">
            <div class="panel product-panel" *ngFor="let productCard of productCards; trackBy: trackByFn">
                <product-results-card [usanaId]="productCard.usanaId" [productGroup]="productCard.productGroup"
                                     (productAddedEvent)="isProductAdded=true" [productShareQty]="1">
                </product-results-card>
            </div>
        </ng-container>
        <div class="panel outro word-wrap" *ngIf="!!productCards">
            <div class="card text-center">
                <h3 class="category-hero-title heading-2" translate="cart.skin.analyzer.recommendations.outro.title"></h3>
                <button type="button" class="button button-primary button-large"
                        [routerLink]="CART_OVERVIEW_ROUTE"
                        translate="cart.continue.checkout"></button>
                <button type="button" class="button button-tertiary button-large"
                        (click)="addAllAndGoToCart()"
                        translate="cart.skin.analyzer.add.all.and.checkout"></button>
                <span translate="cart.skin.analyzer.other.products"></span>
                <a [routerLink]="[CATALOG_ROUTE, -1]" translate="cart.skin.analyzer.other.products.link"></a>
            </div>
        </div>
    </div>
</section>
